import * as Config from '../../config';
import { default as Locale } from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import * as MathLib from '../../utils/Math';
import { GraphIcon } from '../../utils/Icon';
import { AlertInfo, AlertType, AlertRecord, AlertCategories } from "../Types";
import { AlertLogic } from './AlertLogic';
import { findAllStates } from "../../status/index";
import { ContentCategories } from "../../types";

export class Chemistry extends AlertLogic {
    static type = [
        AlertType.PhLow,
        AlertType.PhHigh,
        AlertType.OrpLow,
        AlertType.OrpHigh
    ];
    static category = AlertCategories.WATER_QUIALITY;
    static contentCategories = [ ContentCategories.WATER_QUALITY ];
    static title = [
        Locale.gettext('pH low'),
        Locale.gettext('pH high'),
        Locale.gettext('ORP low'),
        Locale.gettext('ORP high'),
    ];

    getInfo(alert:AlertRecord = this.alert, config:Config.AllConfig = this.allConfigs):AlertInfo {
        // Same for all alert types
        let { body, device, alertData, firstReported } = this.getCommons(alert, config);
        const bowUuid = (body as Config.BodyOfWaterConfig)?.UUID;

        // Varying across alert types
        let cardIllustration = 'pipes_emergency';
        let detailIcon = GraphIcon.getNodeIconName({
            DeviceType: alert.type.indexOf('PH') === 0 ?
                'PHProbe' : 'ORPProbe'
            });
            
        const chemType = alert.type.indexOf('PH') === 0 ?
            this.locale.gettext('pH') :
            this.locale.gettext('ORP')
        ;

        const lowHigh = alert.type.indexOf('LOW') !== -1 ?
            this.locale.gettext('low') :
            this.locale.gettext('high')
        ;

        // alertData.CurrentValue is not updated anymore by the Controller so getting it from the states.
        const bowStates = findAllStates(bowUuid, this.states);
        const currentValue = alert.type.indexOf("PH") === 0 ?
            (bowStates as { PH: number | string})?.PH :
            (bowStates as { ORP: number | string })?.ORP
        ;

        const configuredLimit = this.locale.gettext(
            'Configured limit: %1$s.',
            MathLib.formatAccuracy(alertData?.ConfiguredLimit, 0.01)
        )
        const detailDescription = (currentValue !== "null" && currentValue !== null && typeof currentValue !== "undefined") ?
            (this.locale.gettext('Currently reading %1$s.', MathLib.formatAccuracy(currentValue, 0.01)) + " " + configuredLimit) :
            configuredLimit
        ;

        const detailDescription2 = alert.type.indexOf('PH') === 0
            ? Locale.gettext('Maintaining the right pH level in your pool is crucial for swimmer comfort and equipment longevity. When the pH gets too high or too low, it can lead to various issues, including skin irritation, cloudy water, and reduced chlorine effectiveness.')
            : Locale.gettext('Maintaining the proper ORP level in your pool is essential for effective sanitation and safe swimming conditions. ORP measures how well your pool water can neutralize contaminants, and if the ORP levels get too low, sanitizers become less effective, increasing the risk of algae growth and harmful bacteria.  If it gets too high, it can indicate over-sanitization and can cause swimmer discomfort.');

        const historicalDescriptionShort = [ configuredLimit ];

        const detailDescriptionArr = [
            detailDescription,
            detailDescription2,
        ];
        
        
        /** @todo Eric */
        /*
        const bowChemistry = this.allConfigs?.Chemistry?.find(item => item.BodyOfWaterUUID === bowUuid) || ({} as Config.BowChemistry);
        switch (alert.type) {
        case "PH_LOW":
            if (bowChemistry.DispensingBaseEnabled) {
                detailDescriptionArr.push(Locale.gettext("Check your settings on your soda ash dosing thing to make it more."));
            } else {
                detailDescriptionArr.push(Locale.gettext("You will need to manually add soda ash after testing your water at the pool store"));
            }
            if (bowChemistry.DispensingAcidEnabled) {
                detailDescriptionArr.push(Locale.gettext("Check your settings of acid dosing to make it less"));
            } else {
                detailDescriptionArr.push(Locale.gettext("You will need to manually add acid after testing your water at the pool store"));
            }
            if (bowChemistry.DispensingCO2Enabled) {
                detailDescriptionArr.push(Locale.gettext("PH_LOW, DispensingCO2Enabled"));
            } else {
                detailDescriptionArr.push(Locale.gettext("PH_LOW, NO-DispensingCO2Enabled"));
            }
            break;
        case "PH_HIGHT":
            if (bowChemistry.DispensingBaseEnabled) {
                detailDescriptionArr.push(Locale.gettext("PH_HIGH, BASE"));
            } else {
                detailDescriptionArr.push(Locale.gettext("PH_HIGH, NO-BASE"));
            }
            if (bowChemistry.DispensingAcidEnabled) {
                detailDescriptionArr.push(Locale.gettext("PH_HIGH, ACID"));
            } else {
                detailDescriptionArr.push(Locale.gettext("PH_HIGH, NO-ACID"));
            }
            if (bowChemistry.DispensingCO2Enabled) {
                detailDescriptionArr.push(Locale.gettext("PH_HIGH, DispensingCO2Enabled"));
            } else {
                detailDescriptionArr.push(Locale.gettext("PH_HIGH, NO-DispensingCO2Enabled"));
            }
            break;
        case "ORP_LOW":
            if (bowChemistry.UvSanitizerEnabled) {
                detailDescriptionArr.push(Locale.gettext("ORP_LOW, UvSanitizerEnabled"));
            } else {
                detailDescriptionArr.push(Locale.gettext("ORP_LOW, NO-UvSanitizerEnabled"));
            }
            if (bowChemistry.OzoneEnabled) {
                detailDescriptionArr.push(Locale.gettext("ORP_LOW, OzoneEnabled"));
            } else {
                detailDescriptionArr.push(Locale.gettext("ORP_LOW, NO-OzoneEnabled"));
            }
            if (bowChemistry.DispensingSaltChlorineEnabled) {
                detailDescriptionArr.push(Locale.gettext("ORP_LOW, DispensingSaltChlorineEnabled"));
            } else {
                detailDescriptionArr.push(Locale.gettext("ORP_LOW, NO-DispensingSaltChlorineEnabled"));
            }
            if (bowChemistry.DispensingLiquidChlorineEnabled) {
                detailDescriptionArr.push(Locale.gettext("ORP_LOW, DispensingLiquidChlorineEnabled"));
            } else {
                detailDescriptionArr.push(Locale.gettext("ORP_LOW, NO-DispensingLiquidChlorineEnabled"));
            }
            break;
        case "ORP_HIGHT":
            
            if (bowChemistry.UvSanitizerEnabled) {
                detailDescriptionArr.push(Locale.gettext("ORP_HIGHT, UvSanitizerEnabled"));
            } else {
                detailDescriptionArr.push(Locale.gettext("ORP_HIGHT, NO-UvSanitizerEnabled"));
            }
            if (bowChemistry.OzoneEnabled) {
                detailDescriptionArr.push(Locale.gettext("ORP_HIGHT, OzoneEnabled"));
            } else {
                detailDescriptionArr.push(Locale.gettext("ORP_HIGHT, NO-OzoneEnabled"));
            }
            if (bowChemistry.DispensingSaltChlorineEnabled) {
                detailDescriptionArr.push(Locale.gettext("ORP_HIGHT, DispensingSaltChlorineEnabled"));
            } else {
                detailDescriptionArr.push(Locale.gettext("ORP_HIGHT, NO-DispensingSaltChlorineEnabled"));
            }
            if (bowChemistry.DispensingLiquidChlorineEnabled) {
                detailDescriptionArr.push(Locale.gettext("ORP_HIGHT, DispensingLiquidChlorineEnabled"));
            } else {
                detailDescriptionArr.push(Locale.gettext("ORP_HIGHT, NO-DispensingLiquidChlorineEnabled"));
            }
            break;
        }
        */

        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: this.locale.gettext('%1$s %2$s is %3$s', body.Name, chemType, lowHigh),
            cardDescription: detailDescription,
            cardIllustration: cardIllustration,
            detailIcon,
            detailDescription: null,
            detailDescriptionArr,
            historicalDescriptionShort,
            resolveSummary: this.locale.gettext('%1$s %2$s has normalized', body.Name, chemType)
        });
        alertInfo.contentCategories = Chemistry.contentCategories;
        return alertInfo;
    }

    static mock(type:AlertType, config:Config.AllConfig, subType?:string):AlertRecord {
        let device = config.Config.Devices.find(dev => dev.DeviceType === "PHProbe");
        if ([ 'ORP_LOW', 'ORP_HIGH'].includes(type)) {
            device = config.Config.Devices.find(dev => dev.DeviceType === "ORPProbe");
        }

        let target = config.Config.BodiesOfWater[0]?.PHTarget || 7;
        return new AlertRecord({
            id: Math.floor(Math.random() * 100000),
            uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "ALRT" + type),
            siteId: Math.floor(Math.random() * 100000),
            entityUuid: device.UUID,
            bodyUuid: config.Config.BodiesOfWater[0]?.UUID,
            type: type,
            data: {
                CurrentValue: target - 0.2,
                ConfiguredLimit: target - 0.1
            }
        });
    }
}